import React from 'react';
import { Formik } from 'formik';
import Rating from '@mui/material/Rating';
import { useNavigate, useParams } from "react-router-dom";
import { TextField, Grid, Button, Typography, Box } from '@mui/material';

export const ReviewForm = () => {
  const navigate = useNavigate();
  let { token } = useParams();

  return (
    <Formik
      initialValues={{ rating: 1, comment: '' }}
      validate={values => {
        const errors = {};
        return errors;
      }}
      onSubmit={(values, { setSubmitting }) => {
        setTimeout(() => {
          navigate(`/review/${token}/confirmation`, {state: {values: values}});
          setSubmitting(false);
        }, 400);
      }}
    >
      {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting
        }) => (
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Rating
                    type="rating"
                    name="rating"
                    precision={0.1}
                    defaultValue={1}
                    size="large"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={Number(values.rating)}
                    disabled={isSubmitting}
                  />
                    <span style={{ marginLeft: 8, fontSize: '14px' }}>{Number(values.rating).toFixed(1)}</span>
                </Box>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                type="comment"
                name="comment"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.comment}
                id="filled-multiline-static"
                label="Kommentar"
                multiline
                rows={16}
                // defaultValue="Default Value"
                variant="filled"
                disabled={isSubmitting}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                size={'large'}
                type="submit"
                disabled={isSubmitting}
              >
                Absenden
              </Button>
            </Grid>
          </Grid>
        </form>
      )}
    </Formik>
  );
}